import { useEffect, useState } from "react";
import { Link, useLocation } from "wouter";
import { Bookmark, Package, Wrench, Building2, FileText, Briefcase, FolderKanban, ReceiptText, Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { toggleSaved } from "../lib/saved";

const KIND_META: Record<string, { Icon: any; label: string }> = {
  item: { Icon: Package, label: "Item" }, service: { Icon: Wrench, label: "Service" },
  company: { Icon: Building2, label: "Company" }, person: { Icon: FileText, label: "Résumé" },
  job: { Icon: Briefcase, label: "Job" }, project: { Icon: FolderKanban, label: "Project" }, rfq: { Icon: ReceiptText, label: "RFQ" },
};

export default function Saved() {
  const { user, loading } = useAuth();
  const [, navigate] = useLocation();
  const [items, setItems] = useState<any[] | null>(null);

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [loading, user, navigate]);
  useEffect(() => { if (user) api.savedList().then(setItems).catch(() => setItems([])); }, [user]);
  if (loading || !user) return <div className="container-x py-20 text-center text-mut">Loading…</div>;

  async function remove(it: any) {
    setItems((prev) => (prev ? prev.filter((x) => !(x.kind === it.kind && x.refId === it.refId)) : prev));
    await toggleSaved(it.kind, it.refId);
  }

  return (
    <div className="container-x py-6 max-w-3xl">
      <div className="flex items-center gap-2 mb-1"><Bookmark className="w-6 h-6 text-brand-red" /><h1 className="text-2xl font-extrabold text-navy">Saved Items</h1></div>
      <p className="text-mut text-sm mb-5">Listings you've bookmarked across the marketplace.</p>
      {!items ? (
        <div className="py-16 text-center text-mut"><Loader2 className="w-6 h-6 animate-spin mx-auto" /></div>
      ) : items.length === 0 ? (
        <div className="card p-10 text-center">
          <Bookmark className="w-8 h-8 text-mut mx-auto mb-2" />
          <div className="font-bold text-navy">Nothing saved yet</div>
          <p className="text-sm text-mut mt-1">Tap the bookmark icon on any listing to save it here.</p>
          <Link href="/marketplace" className="btn-navy mt-4 inline-flex">Browse the marketplace</Link>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((it) => {
            const meta = KIND_META[it.kind] || { Icon: Bookmark, label: it.kind };
            const Icon = meta.Icon;
            return (
              <div key={`${it.kind}:${it.refId}`} className="card p-3 flex items-center justify-between gap-3">
                <Link href={it.link} className="flex items-center gap-3 min-w-0 hover:text-brand-red">
                  <div className="w-10 h-10 rounded-lg bg-navy-50 text-navy grid place-items-center shrink-0"><Icon className="w-5 h-5" /></div>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-navy truncate">{it.title}</div>
                    <div className="text-xs text-mut truncate"><span className="chip bg-navy-50 text-navy-600 mr-1">{meta.label}</span>{it.subtitle}</div>
                  </div>
                </Link>
                <button onClick={() => remove(it)} className="btn-ghost h-9 px-3 text-xs text-brand-red shrink-0"><Bookmark className="w-4 h-4 fill-brand-red" />Remove</button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
